import CleaningIcon from '../Images/cleaning-icon.svg'


const appliances = [

    {
        id: 32, 
        image: CleaningIcon,
        option: 'Single Oven',
        desc: 'Unplug appliance, Wipe exterior, Clean interior, Reassemble components, Eco-Friendly Products'  
    },{
        id: 33, 
        image: CleaningIcon,
        option: 'Double Oven',
        desc: 'Unplug appliance, Wipe exterior, Clean interior, Reassemble components, Eco-Friendly Products'  
    },{
        id: 34, 
        image: CleaningIcon,
        option: 'Aga Cooker',
        desc: 'Unplug appliance, Wipe exterior, Clean interior, Reassemble components, Eco-Friendly Products'  
    },

]


export default appliances;